/** @deprecated since v5.0. Please use mat-table instead */
export enum TerraDataTableSortOrderEnum {
    descending = 'desc',
    ascending = 'asc'
}
